var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("q-card", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.progresso,
                expression: "progresso"
              }
            ],
            staticStyle: { height: "1px !important" }
          },
          [
            _c("q-progress", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.progresso,
                  expression: "progresso"
                }
              ],
              attrs: { indeterminate: true }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.apiRelatorio,
                expression: "apiRelatorio"
              }
            ],
            staticClass: "row"
          },
          [
            _c(
              "div",
              {
                staticClass: "col-sm-12 text-right",
                staticStyle: { "padding-bottom": "5px" }
              },
              [
                _c(
                  "q-btn",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.apiRelatorio,
                        expression: "apiRelatorio"
                      }
                    ],
                    attrs: { color: "secondary", flat: "", round: "" },
                    on: { click: _vm.imprimirRelatorio }
                  },
                  [
                    _c("q-icon", { attrs: { name: "fa fa-print" } }),
                    _c("q-tooltip", [_vm._v("Imprimir relatório")])
                  ],
                  1
                )
              ],
              1
            )
          ]
        ),
        _c(
          "div",
          { class: _vm.divClassRow, style: _vm.scrollHorizontalEstilo },
          [
            _c(
              "table",
              {
                staticStyle: { width: "100%" },
                attrs: { cellspacing: "0", cellpadding: "0" }
              },
              [
                _c("thead", [
                  _c(
                    "tr",
                    _vm._l(_vm.colunas, function(coluna) {
                      return _c(
                        "th",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                typeof coluna.cabecalhoClique === "undefined" &&
                                (coluna.conteudoTipo !== "operacao" ||
                                  (coluna.conteudoTipo === "operacao" &&
                                    _vm.exibirColunaOperacoes)) &&
                                (typeof coluna.esconderColuna === "undefined" ||
                                  (typeof coluna.esconderColuna !==
                                    "undefined" &&
                                    coluna.esconderColuna === false)),
                              expression:
                                "(((typeof coluna.cabecalhoClique === 'undefined') && ((coluna.conteudoTipo !== 'operacao') || coluna.conteudoTipo === 'operacao' && exibirColunaOperacoes))  && (typeof coluna.esconderColuna === 'undefined' || ( typeof coluna.esconderColuna !== 'undefined' && coluna.esconderColuna === false)))"
                            }
                          ],
                          key: coluna.id,
                          class: coluna.cabecalhoClasse,
                          attrs: { width: coluna.largura }
                        },
                        [
                          coluna.cabecalhoTooltip !== "" &&
                          coluna.cabecalhoTooltip !== undefined &&
                          coluna.cabecalhoTooltip !== null
                            ? _c("q-tooltip", [
                                _vm._v(_vm._s(coluna.cabecalhoTooltip))
                              ])
                            : _vm._e(),
                          typeof coluna.cabecalhoClique === "undefined"
                            ? _c(
                                "div",
                                [
                                  coluna.cabecalhoEtiqueta === "checkBox"
                                    ? _c("q-checkbox", {
                                        attrs: {
                                          "true-value": true,
                                          "false-value": false
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.atualizarModelo($event)
                                          }
                                        },
                                        model: {
                                          value: _vm.customModel,
                                          callback: function($$v) {
                                            _vm.customModel = $$v
                                          },
                                          expression: "customModel"
                                        }
                                      })
                                    : _vm._e(),
                                  coluna.cabecalhoEtiqueta !== "checkBox"
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(coluna.cabecalhoEtiqueta) +
                                            "\n                "
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              )
                            : _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        typeof coluna.cabecalhoClique !==
                                          "undefined" ||
                                        coluna.cabecalhoClique === ".",
                                      expression:
                                        "((typeof coluna.cabecalhoClique !== 'undefined') || (coluna.cabecalhoClique === '.'))"
                                    }
                                  ],
                                  attrs: { width: coluna.largura }
                                },
                                [
                                  _c(
                                    "q-btn",
                                    {
                                      staticClass: "btn",
                                      attrs: {
                                        push: "",
                                        small: "",
                                        flat: "",
                                        left: "",
                                        disabled: !coluna.cabecalhoPermissao
                                      },
                                      on: {
                                        click: function($event) {
                                          coluna.cabecalhoClique(
                                            coluna,
                                            _vm.dados
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { style: coluna.cabecalhoEstilo },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(coluna.cabecalhoEtiqueta) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "q-tooltip",
                                        {
                                          attrs: {
                                            delay:
                                              coluna.cabecalhoBotaoTooltipDelay
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(coluna.cabecalhoBotaoTooltip)
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "block",
                                        "text-align": "center",
                                        margin: "0 auto",
                                        "font-size": "12px",
                                        color: "navy"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _c("small", [
                                          _vm._v(_vm._s(coluna.diaSemana) + " ")
                                        ])
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "block",
                                        "text-align": "center",
                                        margin: "0 auto",
                                        "font-size": "12px"
                                      }
                                    },
                                    [
                                      coluna.subCabecalho
                                        ? _c(
                                            "q-btn",
                                            {
                                              staticClass: "btn",
                                              attrs: {
                                                push: "",
                                                small: "",
                                                flat: "",
                                                left: "",
                                                disabled: !coluna.subCabecalhoPermissao
                                              },
                                              on: {
                                                click: function($event) {
                                                  coluna.subCabecalhoClique(
                                                    coluna,
                                                    _vm.dados
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  style:
                                                    coluna.subCabecalhoEstilo
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        coluna.subCabecalhoEtiqueta
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "q-tooltip",
                                                {
                                                  attrs: {
                                                    delay:
                                                      coluna.subCabecalhoBotaoTooltipDelay
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      coluna.subCabecalhoBotaoTooltip
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                        ],
                        1
                      )
                    })
                  )
                ]),
                _vm.elementosPorPagina !== null
                  ? _c("tfoot", [
                      _c("tr", [
                        _c("td", { attrs: { colspan: this.colunas.length } }, [
                          _c(
                            "div",
                            { staticClass: "float-right" },
                            [
                              _c("q-pagination", {
                                attrs: {
                                  ellipses: true,
                                  min: 1,
                                  max: _vm.paginaTotal,
                                  "max-pages": 6,
                                  "direction-links": "",
                                  "boundary-links": ""
                                },
                                model: {
                                  value: _vm.paginaAtual,
                                  callback: function($$v) {
                                    _vm.paginaAtual = $$v
                                  },
                                  expression: "paginaAtual"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _c(
                  "tbody",
                  [
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.dados.length == 0,
                            expression: "dados.length == 0"
                          }
                        ]
                      },
                      [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "50" }
                          },
                          [_vm._v(_vm._s(_vm.msgNenhumRegistroEncontrado()))]
                        )
                      ]
                    ),
                    _vm._l(_vm.dados, function(linha, linhaIdx) {
                      return _c(
                        "div",
                        { key: linha.a, staticStyle: { display: "contents" } },
                        [
                          _c(
                            "tr",
                            {
                              class: linhaIdx % 2 === 0 ? "bg-white" : "",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function() {
                                  return _vm.expandirLinha(linha, linhaIdx)
                                }
                              }
                            },
                            [
                              linha.colunas[0].primeiraColunaFixa === true
                                ? _c(
                                    "td",
                                    { staticStyle: { "padding-left": "0px" } },
                                    [
                                      _c("span", {
                                        staticStyle: { visibility: "hidden" },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.maiorTextoPrimeiraColuna(
                                              _vm.dados
                                            )
                                          )
                                        }
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "coluna-fixa",
                                          staticStyle: {
                                            "background-color": "#D0D0D0"
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticStyle: {
                                              visibility: "hidden"
                                            },
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.maiorTextoPrimeiraColuna(
                                                  _vm.dados
                                                )
                                              )
                                            }
                                          })
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "coluna-fixa" },
                                        [
                                          _c("span", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  linha.colunas[0]
                                                    .conteudoTextoHtml,
                                                expression:
                                                  "linha.colunas[0].conteudoTextoHtml"
                                              }
                                            ],
                                            class:
                                              linha.colunas[0].celulaClasse,
                                            style:
                                              linha.colunas[0].celulaEstilo,
                                            domProps: {
                                              innerHTML: _vm._s(
                                                linha.colunas[0]
                                                  .conteudoTextoHtml
                                              )
                                            }
                                          }),
                                          _c(
                                            "span",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    linha.colunas[0]
                                                      .propriedade,
                                                  expression:
                                                    "linha.colunas[0].propriedade"
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getPropriedade(
                                                    linha.colunas[0],
                                                    linha
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._l(
                                _vm.colunasSemprimeiraColunaFixa(linha.colunas),
                                function(coluna) {
                                  return _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            (coluna.conteudoTipo !==
                                              "operacao" ||
                                              (coluna.conteudoTipo ===
                                                "operacao" &&
                                                _vm.exibirColunaOperacoes)) &&
                                            (typeof coluna.esconderColuna ===
                                              "undefined" ||
                                              (typeof coluna.esconderColuna !==
                                                "undefined" &&
                                                coluna.esconderColuna ===
                                                  false)),
                                          expression:
                                            "(((coluna.conteudoTipo !== 'operacao') || coluna.conteudoTipo === 'operacao' && exibirColunaOperacoes) && (typeof coluna.esconderColuna === 'undefined' || ( typeof coluna.esconderColuna !== 'undefined' && coluna.esconderColuna === false)))"
                                        }
                                      ],
                                      key: coluna.id,
                                      class:
                                        (linha.expandido
                                          ? ""
                                          : "texto-elipse ") +
                                        (coluna.conteudoClasse
                                          ? coluna.conteudoClasse
                                          : /^((cod)|(dat)|(num)|(val))/.test(
                                              coluna.propriedade
                                                ? coluna.propriedade
                                                    .split(".")
                                                    .slice(-1)
                                                : ""
                                            )
                                            ? "text-center"
                                            : "text-left q-pa-sm"),
                                      style:
                                        "padding: 3px 3px !important; " +
                                        (coluna.conteudoEstilo
                                          ? coluna.conteudoEstilo
                                          : ""),
                                      attrs: { width: coluna.largura }
                                    },
                                    [
                                      coluna.conteudoTipo !== "operacao" &&
                                      !coluna.primeiraColunaFixa
                                        ? _vm._t("default", [
                                            coluna.conteudoTipo === "checkBox"
                                              ? _c("q-checkbox", {
                                                  attrs: {
                                                    val: linhaIdx,
                                                    disable: _vm.linhaDesabilitada(
                                                      linha
                                                    )
                                                  },
                                                  model: {
                                                    value: _vm.checkArray,
                                                    callback: function($$v) {
                                                      _vm.checkArray = $$v
                                                    },
                                                    expression: "checkArray"
                                                  }
                                                })
                                              : _vm._e(),
                                            coluna.conteudoTipo === "radio"
                                              ? _c("q-radio", {
                                                  attrs: {
                                                    val: linhaIdx,
                                                    disable: _vm.linhaDesabilitada(
                                                      linha
                                                    )
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.indexSelecionadoRadio,
                                                    callback: function($$v) {
                                                      _vm.indexSelecionadoRadio = $$v
                                                    },
                                                    expression:
                                                      "indexSelecionadoRadio"
                                                  }
                                                })
                                              : coluna.conteudoTipo === "icone"
                                                ? _c("q-icon", {
                                                    class: coluna.celulaClasse,
                                                    style: coluna.celulaEstilo,
                                                    attrs: {
                                                      center: "",
                                                      name:
                                                        coluna.conteudoIcone,
                                                      size:
                                                        coluna.conteudoIconeTamanho,
                                                      color: coluna.conteudoCor,
                                                      disabled:
                                                        !coluna.permissao ||
                                                        _vm.linhaDesabilitada(
                                                          linha
                                                        )
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.conteudoClique(
                                                          coluna,
                                                          linha
                                                        )
                                                      }
                                                    }
                                                  })
                                                : coluna.conteudoTipo ===
                                                  "icone2"
                                                  ? _vm._t(
                                                      coluna.conteudoIcone,
                                                      [
                                                        coluna.valor1(linha)
                                                          ? _c(
                                                              "q-icon",
                                                              {
                                                                class:
                                                                  coluna.celulaClasse1,
                                                                style:
                                                                  coluna.celulaEstilo,
                                                                attrs: {
                                                                  center: "",
                                                                  color:
                                                                    coluna.cor,
                                                                  name:
                                                                    coluna.conteudoIcone,
                                                                  size:
                                                                    coluna.conteudoIconeTamanho
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "q-tooltip",
                                                                  {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value:
                                                                          coluna.conteudoTooltip1,
                                                                        expression:
                                                                          "coluna.conteudoTooltip1"
                                                                      }
                                                                    ],
                                                                    attrs: {
                                                                      self:
                                                                        "bottom left"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          coluna.conteudoTooltip1
                                                                        ) +
                                                                        " "
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          : coluna.valor2(linha)
                                                            ? _c(
                                                                "q-icon",
                                                                {
                                                                  class:
                                                                    coluna.celulaClasse2,
                                                                  style:
                                                                    coluna.celulaEstilo,
                                                                  attrs: {
                                                                    center: "",
                                                                    name:
                                                                      coluna.conteudoIcone,
                                                                    size:
                                                                      coluna.conteudoIconeTamanho,
                                                                    color:
                                                                      coluna.cor
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "q-tooltip",
                                                                    {
                                                                      directives: [
                                                                        {
                                                                          name:
                                                                            "show",
                                                                          rawName:
                                                                            "v-show",
                                                                          value:
                                                                            coluna.conteudoTooltip2,
                                                                          expression:
                                                                            "coluna.conteudoTooltip2"
                                                                        }
                                                                      ],
                                                                      attrs: {
                                                                        self:
                                                                          "bottom left"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            coluna.conteudoTooltip2
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e()
                                                      ],
                                                      { row: linha }
                                                    )
                                                  : coluna.conteudoTipo ===
                                                    "botao"
                                                    ? _c(
                                                        "q-btn",
                                                        {
                                                          attrs: {
                                                            round: "",
                                                            small: "",
                                                            flat: "",
                                                            color:
                                                              coluna.conteudoCor,
                                                            disable:
                                                              !coluna.permissao ||
                                                              _vm.linhaDesabilitada(
                                                                linha
                                                              )
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              coluna.conteudoClique(
                                                                linha,
                                                                coluna
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("q-icon", {
                                                            class:
                                                              coluna.celulaClasse,
                                                            attrs: {
                                                              name:
                                                                coluna.conteudoIcone
                                                            }
                                                          }),
                                                          _c(
                                                            "q-tooltip",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    coluna.conteudoTooltip,
                                                                  expression:
                                                                    "coluna.conteudoTooltip"
                                                                }
                                                              ],
                                                              attrs: {
                                                                self:
                                                                  "bottom left"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    coluna.conteudoTooltip
                                                                  ) +
                                                                  " "
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : coluna.conteudoTipo ===
                                                      "campoTexto"
                                                      ? _c("g-input", {
                                                          attrs: {
                                                            tipo: "text",
                                                            cor:
                                                              coluna.conteudoCor,
                                                            desabilitar: _vm.linhaDesabilitada(
                                                              linha
                                                            )
                                                          },
                                                          model: {
                                                            value:
                                                              coluna[
                                                                coluna
                                                                  .propriedade
                                                              ],
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                coluna,
                                                                coluna.propriedade,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "coluna[coluna.propriedade]"
                                                          }
                                                        })
                                                      : coluna.conteudoTipo ===
                                                        "select"
                                                        ? _c("g-select", {
                                                            attrs: {
                                                              icone:
                                                                coluna.conteudoIcone,
                                                              etiqueta:
                                                                coluna.conteudoEtiqueta,
                                                              itens:
                                                                _vm.selectItens,
                                                              "item-valor":
                                                                coluna.conteudoItemValor,
                                                              "item-etiqueta":
                                                                coluna.conteudoItemEtiqueta,
                                                              desabilitar: !coluna.permissao
                                                            },
                                                            model: {
                                                              value:
                                                                coluna.opcaoSelecionada,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  coluna,
                                                                  "opcaoSelecionada",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "coluna.opcaoSelecionada"
                                                            }
                                                          })
                                                        : coluna.conteudoTipo ===
                                                          "areaTexto"
                                                          ? _c("q-input", {
                                                              staticStyle: {
                                                                border:
                                                                  "1px solid grey",
                                                                "box-shadow":
                                                                  "1px 1px grey"
                                                              },
                                                              attrs: {
                                                                type:
                                                                  "textarea",
                                                                "min-height": 50,
                                                                rows: "10",
                                                                "hide-underline":
                                                                  "",
                                                                disable: _vm.linhaDesabilitada(
                                                                  linha
                                                                )
                                                              },
                                                              model: {
                                                                value:
                                                                  coluna[
                                                                    coluna
                                                                      .propriedade
                                                                  ],
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    coluna,
                                                                    coluna.propriedade,
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "coluna[coluna.propriedade]"
                                                              }
                                                            })
                                                          : coluna.conteudoTipo ===
                                                            "texto"
                                                            ? _vm._t(
                                                                coluna.propriedade,
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      class:
                                                                        coluna.celulaClasse,
                                                                      style:
                                                                        coluna.celulaEstilo
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          coluna.conteudoTexto
                                                                        )
                                                                      )
                                                                    ]
                                                                  ),
                                                                  _c("span", {
                                                                    directives: [
                                                                      {
                                                                        name:
                                                                          "show",
                                                                        rawName:
                                                                          "v-show",
                                                                        value:
                                                                          coluna.conteudoTextoHtml,
                                                                        expression:
                                                                          "coluna.conteudoTextoHtml"
                                                                      }
                                                                    ],
                                                                    class:
                                                                      coluna.celulaClasse,
                                                                    style:
                                                                      coluna.celulaEstilo,
                                                                    domProps: {
                                                                      innerHTML: _vm._s(
                                                                        coluna.conteudoTextoHtml
                                                                      )
                                                                    }
                                                                  })
                                                                ],
                                                                { row: linha }
                                                              )
                                                            : coluna.conteudoTipo ===
                                                              "badge"
                                                              ? _c(
                                                                  "q-chip",
                                                                  {
                                                                    attrs: {
                                                                      color: _vm.getCorBadge(
                                                                        linha,
                                                                        coluna
                                                                      ),
                                                                      dense: ""
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                    " +
                                                                        _vm._s(
                                                                          _vm.getEtiquetaBadge(
                                                                            linha,
                                                                            coluna
                                                                          )
                                                                        ) +
                                                                        "\n                  "
                                                                    )
                                                                  ]
                                                                )
                                                              : coluna.conteudoTipo ===
                                                                "expand"
                                                                ? _c(
                                                                    "q-btn",
                                                                    {
                                                                      staticClass:
                                                                        "btn-operacao",
                                                                      attrs: {
                                                                        round:
                                                                          "",
                                                                        small:
                                                                          "",
                                                                        flat:
                                                                          "",
                                                                        color:
                                                                          "primary"
                                                                      },
                                                                      on: {
                                                                        click: function(
                                                                          evt
                                                                        ) {
                                                                          return _vm.expandirLinha(
                                                                            linha,
                                                                            linhaIdx,
                                                                            evt
                                                                          )
                                                                        }
                                                                      }
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "q-icon",
                                                                        {
                                                                          attrs: {
                                                                            name:
                                                                              linha.iconeExp ||
                                                                              "fas fa-angle-down",
                                                                            size:
                                                                              "16px"
                                                                          }
                                                                        }
                                                                      )
                                                                    ],
                                                                    1
                                                                  )
                                                                : _vm._t(
                                                                    coluna.propriedade,
                                                                    [
                                                                      _vm._v(
                                                                        "\n                    " +
                                                                          _vm._s(
                                                                            _vm.getPropriedade(
                                                                              coluna,
                                                                              linha
                                                                            )
                                                                          ) +
                                                                          "\n                    "
                                                                      ),
                                                                      _c(
                                                                        "q-tooltip",
                                                                        {
                                                                          attrs: {
                                                                            anchor:
                                                                              "top middle",
                                                                            self:
                                                                              "bottom middle",
                                                                            offset: [
                                                                              10,
                                                                              10
                                                                            ],
                                                                            delay: 1
                                                                          }
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                      " +
                                                                              _vm._s(
                                                                                _vm.getPropriedade(
                                                                                  coluna,
                                                                                  linha
                                                                                )
                                                                              ) +
                                                                              "\n                    "
                                                                          )
                                                                        ]
                                                                      )
                                                                    ],
                                                                    {
                                                                      row: linha
                                                                    }
                                                                  )
                                          ])
                                        : _vm._e(),
                                      coluna.conteudoTipo === "operacao" &&
                                      !coluna.primeiraColunaFixa
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "q-fab",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        _vm.exibirColunaOperacoesQFab,
                                                      expression:
                                                        "exibirColunaOperacoesQFab"
                                                    }
                                                  ],
                                                  ref:
                                                    "colunaOperacoesQFab_" +
                                                    linhaIdx,
                                                  refInFor: true,
                                                  staticClass:
                                                    "style-qFab style-qFabActionIcone",
                                                  attrs: {
                                                    direction: "left",
                                                    color: "teal",
                                                    flat: "",
                                                    icon: "fas fa-angle-left",
                                                    "active-icon":
                                                      "fas fa-angle-right",
                                                    outline: "",
                                                    small: "",
                                                    round: ""
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.operacoesQFab,
                                                  function(acao) {
                                                    return _c(
                                                      "q-fab-action",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "show",
                                                            rawName: "v-show",
                                                            value: _vm.acaoVisivel(
                                                              linha,
                                                              acao
                                                            ),
                                                            expression:
                                                              "acaoVisivel(linha, acao)"
                                                          }
                                                        ],
                                                        key: acao.tooltip,
                                                        staticClass:
                                                          "style-qFabAction",
                                                        attrs: {
                                                          color: acao.cor,
                                                          disabled:
                                                            !_vm.acaoPermissao(
                                                              linha,
                                                              acao
                                                            ) ||
                                                            _vm.linhaDesabilitada(
                                                              linha
                                                            ),
                                                          icon: acao.icone,
                                                          small: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            acao.clique(linha)
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "q-tooltip",
                                                          {
                                                            directives: [
                                                              {
                                                                name: "show",
                                                                rawName:
                                                                  "v-show",
                                                                value:
                                                                  acao.tooltip,
                                                                expression:
                                                                  "acao.tooltip"
                                                              }
                                                            ]
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  acao.tooltip
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                )
                                              ),
                                              _vm._l(_vm.operacoes, function(
                                                acao
                                              ) {
                                                return _c(
                                                  "span",
                                                  { key: acao.tooltip },
                                                  [
                                                    _vm.acaoVisivel(linha, acao)
                                                      ? _c(
                                                          "q-btn",
                                                          {
                                                            staticClass:
                                                              "btn-operacao",
                                                            attrs: {
                                                              round: "",
                                                              small: "",
                                                              flat: "",
                                                              color: acao.cor,
                                                              disabled:
                                                                !_vm.acaoPermissao(
                                                                  linha,
                                                                  acao
                                                                ) ||
                                                                _vm.linhaDesabilitada(
                                                                  linha
                                                                )
                                                            },
                                                            on: {
                                                              click: function(
                                                                evt
                                                              ) {
                                                                return _vm._proxy_operacao(
                                                                  evt,
                                                                  acao,
                                                                  linha
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("q-icon", {
                                                              attrs: {
                                                                name:
                                                                  acao.icone,
                                                                size: "18px"
                                                              }
                                                            }),
                                                            _c(
                                                              "q-tooltip",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name:
                                                                      "show",
                                                                    rawName:
                                                                      "v-show",
                                                                    value:
                                                                      acao.tooltip,
                                                                    expression:
                                                                      "acao.tooltip"
                                                                  }
                                                                ],
                                                                attrs: {
                                                                  anchor:
                                                                    "top left"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle: {
                                                                      "font-size":
                                                                        "13px"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                          " +
                                                                        _vm._s(
                                                                          acao.tooltip
                                                                        ) +
                                                                        "\n                        "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              })
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                }
                              )
                            ],
                            2
                          ),
                          _c(
                            "tr",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    linha.expandido &&
                                    _vm._colunasExpand.length > 0,
                                  expression:
                                    "linha.expandido && _colunasExpand.length > 0"
                                }
                              ],
                              class: linhaIdx % 2 === 0 ? "bg-white" : ""
                            },
                            [
                              _c(
                                "td",
                                {
                                  staticClass: "q-pb-md",
                                  attrs: { colspan: "100%" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "row q-pl-sm q-pr-sm" },
                                    _vm._l(_vm._colunasExpand, function(
                                      colunaExp
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: colunaExp.propriedade,
                                          class: colunaExp.classe
                                        },
                                        [
                                          colunaExp.tipo === "fullbadge"
                                            ? _c(
                                                "q-badge",
                                                {
                                                  attrs: {
                                                    color: colunaExp.cor
                                                  }
                                                },
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        colunaExp.etiqueta
                                                      ) + ": "
                                                    )
                                                  ]),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.getPropriedade(
                                                          colunaExp,
                                                          linha
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "div",
                                                [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        colunaExp.etiqueta
                                                      ) + ": "
                                                    )
                                                  ]),
                                                  colunaExp.tipo === "badge"
                                                    ? _c(
                                                        "q-badge",
                                                        {
                                                          attrs: {
                                                            color: colunaExp.cor
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                _vm.getPropriedade(
                                                                  colunaExp,
                                                                  linha
                                                                )
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ]
                                                      )
                                                    : _c("div", [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm.getPropriedade(
                                                                colunaExp,
                                                                linha
                                                              )
                                                            ) +
                                                            "\n                      "
                                                        )
                                                      ])
                                                ],
                                                1
                                              )
                                        ],
                                        1
                                      )
                                    })
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ]
            )
          ]
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.exibirMensagemEmBaixoDoDataTable,
              expression: "exibirMensagemEmBaixoDoDataTable"
            }
          ],
          staticClass: "row"
        },
        [
          _c(
            "div",
            {
              staticClass: "col-sm-12 text-right",
              staticStyle: { padding: "10px" }
            },
            [_c("div", [_vm._v(_vm._s(_vm.mensagem))])]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }